export default "__VITE_ASSET__CVO7hGnn__"